/**
 * The org's installed PowerApps, shaped as children of the sidebar "Apps" group.
 *
 * Deliberately without an `activeOn`: every app resolves to the same route name
 * (`powerapp`), so a route-name criterion cannot tell one app from another. Sharing
 * `activeOn: ['powerapp']` across all of them made SidebarGroup fall back to the first
 * app in the registry, which lit up whichever app was actually open — and lit up even
 * when the open app was not in this list at all. The slug is the discriminator, and it
 * already travels in the resolved path of `to`, which SidebarGroup matches on first.
 *
 * @param {Array<{slug: string, name: string}>} apps - registry payload
 * @param {Function} accountScopedRoute - from `useAccount`
 * @returns {Array<Object>} sidebar children
 */
export function buildPowerAppItems(apps, accountScopedRoute) {
  return apps.map(app => ({
    name: `powerapp-${app.slug}`,
    label: app.name,
    to: accountScopedRoute('powerapp', { slug: app.slug }),
  }));
}

/**
 * O grupo "Apps" inteiro, e não só os filhos.
 *
 * Existe porque a declaração morava solta dentro do `computed` de `Sidebar.vue`, onde
 * nenhum teste a alcançava: mutar `expandOnly` para `false` ali não derrubava exemplo
 * nenhum, e a metade que conserta o defeito ficava sem guarda. O componente estava
 * coberto; a LIGAÇÃO dele, não — que é onde o defeito realmente morava.
 *
 * `expandOnly` é o coração: cada app abre na rota autônoma `powerapp`, que renderiza fora
 * da casca do OS. Navegar no clique do cabeçalho jogava a pessoa dentro do primeiro app
 * (para um super admin, o restrito "Chamados") e desmontava a própria barra lateral no
 * caminho, deixando os outros sem volta.
 *
 * @param {Array<Object>} children - saída de `buildPowerAppItems`
 * @param {string} label - rótulo já traduzido
 * @param {Function} accountScopedRoute - de `useAccount`
 * @returns {Object} o item de menu do grupo Apps
 */
export function buildPowerAppsGroup(children, label, accountScopedRoute) {
  const base = { name: 'Apps', label, icon: 'i-lucide-layout-grid' };
  if (!children.length) {
    return {
      ...base,
      to: accountScopedRoute('powerapps_index'),
      activeOn: ['powerapps_index', 'powerapp'],
    };
  }
  return { ...base, children, expandOnly: true };
}
